import React, { Component } from "react";
import { Checkbox } from "antd";
import "../RegistrationCSS.css";
import { SOURCE_KHOPOLI } from "../../../../constants";

class Instructions extends Component {
  render() {
    if (window.location.pathname.includes(SOURCE_KHOPOLI)) {
      return (
        <div className="row form-box">
          <legend className="form-legend">Important Instructions</legend>
          <div className="col-lg-12 col-md-12">
            <ul className="align-ul">
              <li className="align-li instructions-font-size">
                Kindly Keep GST, PAN, TAN, Customer Declaration 194Q & CIN (if applicable)
                soft copies ready for uploading in the required column.
              </li>
              <li className="align-li instructions-font-size">
                In case of GST, uploaded certificate copy should contain the
                address for which registration is being done.
              </li>
              <li className="align-li instructions-font-size">
                If in case delivery address is not available in the certificate
                copy of GST, declaration letter on letter head to be provided.
                Draft letter copy (attached) –
                <a
                  href={`${
                    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
                      ? process.env.REACT_APP_PROJECT_ROUTE
                      : ""
                  }/GST Declaration.docx`}
                  download
                  className="download-file"
                >
                  Please download from here
                </a>
                . This shall be applicable only creation of ship to
                code/delivery address code only.
              </li>
              <li className="align-li instructions-font-size">
                  Business transactions are subject to jurisdiction of designated court only.
                  The sale of goods is subject to the terms and conditions mentioned in the
                  sales contract / order acceptance.
              </li>
              <li className="align-li instructions-font-size">
                The buyer shall furnish applicable declarations, forms,
                certificates etc duly endorsed by Tax Authorities wherever
                applicable within stipulated time, failing which the buyer will
                be compelled to raise supplementary invoice / debit note for
                such difference in tax amount along with interest, penalty
                imposed by the concerned Tax Authorities if any.
              </li>
              <li className="align-li instructions-font-size">
                In the case of Ex-works Sales seller's risk and responsibilities ceases upon
                delivery at Ex-works designated location or any other place of supply and
                creation of E-way Bill is on the onus of buyer or transporter.
              </li>
              <li className="align-li instructions-font-size">
                Weight and Quantity as indicated in INVOICE at the time of dispatch from designated
                location or other place of supply will be final and any correction on INVOICE is not possible.
              </li>
              <li className="align-li instructions-font-size">
                As per Section 139A (5E) of Income Tax Act, 1961, PAN and
                Aadhaar Number can be used interchangeably. Further to that, As
                per Section 139AAA of Income Tax Act, 1961 read with Rule 114AAA
                of Income Tax Rules, 1962, if PAN and Aadhaar is not linked then
                PAN becomes inoperative. If PAN is inoperative then higher TDS/
                TCS rates are applicable.. Accordingly, the Aadhaar No. is being
                obtained from you only for using the Aadhaar interchangeably
                with PAN and validating the interlinking of PAN and Aadhaar at
                Income Tax Department’s Website.
              </li>
              <li className="instructions-font-size">
                We understand and acknowledge that as part of the
                Contract/Agreement/transaction, AMNS need to have access and
                process our certain personal information including Aadhar number
                of proprietor/promoter. We hereby provide our express consent
                for AMNS and/or its agents to have access to, use, store and
                process all such personal information as may be shared from time
                to time as part of the transaction/contract/Agreement in all
                reasonable ways for fulfilling the obligations under the
                Agreement/Contract.
              </li>
            </ul>
            <br />
            <div className="instructions-font-size">
              <label>
                <label className="instructions-text">
                  <input
                    type="checkbox"
                    id="instructions"
                    className="dark-checkbox"
                    onChange={(e) => this.props.onChange(e.target.checked)}
                  />
                  <b>
                    I / We have read the instructions, terms & conditions and{" "}
                    <a href="PrivacyPolicy" target="_blank" className="links">
                      privacy policy.
                    </a>{" "}
                    Will follow them during registration.
                  </b>
                </label>
              </label>
              <br />
              <br />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row form-box">
        <legend className="form-legend">Important Instructions</legend>
        <div className="col-lg-12 col-md-12">
          <ul className="align-ul">
            <li className="align-li instructions-font-size">
              Kindly keep GST (all 3 pages), TAN & PAN, and 194Q Declaration Letter (with current date & financial year on letterhead, if applicable) ready for upload.
            </li>
            <li className="align-li instructions-font-size">
              If you are a Limited or Private Limited company, submission of a Company Identification Certificate (CIN) is mandatory.
            </li>
            {/*<li className="align-li instructions-font-size">*/}
            {/*  If in case delivery address is not available in the certificate*/}
            {/*  copy of GST, declaration letter on letter head to be provided.*/}
            {/*  Draft letter copy (attached) –*/}
            {/*  <a*/}
            {/*    href={`${*/}
            {/*      process.env.REACT_APP_PROJECT_ROUTE !== "/null"*/}
            {/*        ? process.env.REACT_APP_PROJECT_ROUTE*/}
            {/*        : ""*/}
            {/*    }/GST Declaration.docx`}*/}
            {/*    download*/}
            {/*    className="download-file"*/}
            {/*  >*/}
            {/*    Please download from here*/}
            {/*  </a>*/}
            {/*  . This shall be applicable only creation of ship to code/delivery*/}
            {/*  address code only.*/}
            {/*</li>*/}
            <li className="align-li instructions-font-size">
              All attachments must be in PDF or JPG/JPEG format only. Each file must not exceed 10 MB.
            </li>
            <li className="align-li instructions-font-size">
              If GST unregistered, upload a GST Self-Declaration with address, date, seal, and signature of authorized personnel.
            </li>
            <li className="align-li instructions-font-size">
              In case of GST, uploaded certificate copy should contain the address for which registration is being done.
            </li>
            <li className="align-li instructions-font-size">
              If delivery address is not mentioned in the GST certificate, upload a declaration letter on letterhead with: - Same PO number, Delivery address, Date, Sign & stamp of customer
              <a
                  href={`${
                    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
                      ? process.env.REACT_APP_PROJECT_ROUTE
                      : ""
                  }/GST Declaration.docx`}
                  download
                  className="download-file"
                >
                  (Download draft letter here).
                </a>
              This is only applicable for creation of Ship-To/Delivery Address Codes.
            </li>
            <li className="align-li instructions-font-size">
              Business transactions are subject to jurisdiction of SURAT court only. Sale of goods is subject to the terms and conditions mentioned in the sales contract / order acceptance.
            </li>
            <li className="instructions-font-size">
              The buyer shall furnish applicable declarations, forms, certificates etc. duly endorsed by Tax Authorities wherever applicable within stipulated time, failing which the buyer will be compelled to raise supplementary invoice / debit note for such difference in tax amount along with interest, penalty imposed by the concerned Tax Authorities if any.
            </li>
            <li className="instructions-font-size">
              In the case of Ex-works Sales seller's risk and responsibilities ceases upon delivery at Ex-works Hazira or any other place of supply and creation of E-way Bill is on the onus of buyer or transporter.
            </li>
            <li className="instructions-font-size">
              Weight and Quantity as indicated in INVOICE at the time of dispatch from Hazira or other place of supply will be final and any correction on INVOICE is not possible.
            </li>
            <li className="instructions-font-size">
              As per Section 139A (5E) of Income Tax Act, 1961, PAN and Aadhaar Number can be used interchangeably. Further to that, As per Section 139AAA of Income Tax Act, 1961 read with Rule 114AAA of Income Tax Rules, 1962, if PAN and Aadhaar is not linked then PAN becomes inoperative. If PAN is inoperative then higher TDS/ TCS rates are applicable. Accordingly, the Aadhaar No. is being obtained from you only for using the Aadhaar interchangeably with PAN and validating the interlinking of PAN and Aadhaar at Income Tax Department’s Website.
            </li>
            <li className="instructions-font-size">
              We understand and acknowledge that as part of the Contract/Agreement/transaction, AMNSI need to have access and process our certain personal information including Aadhar number of proprietor/promoters. We hereby provide our express consent for AMNSI and/or its agents to have access to, use, store and process all such personal information as may be shared from time to time as part of the transaction/contract/Agreement in all reasonable ways for fulfilling the obligations under the Agreement/Contract.
            </li>
            <li className="instructions-font-size">
              Fields marked with an asterisk (*) are mandatory.
            </li>
            <li className="instructions-font-size">
              For international customers, upload a Company Identification Certificate, Tax Certificate, or any government-issued document verifying name and address.
            </li>
          </ul>
          <br />
          <div className="instructions-font-size">
            <label>
              <label className="instructions-text">
                <input
                  type="checkbox"
                  id="instructions"
                  className="dark-checkbox"
                  onChange={(e) => this.props.onChange(e.target.checked)}
                />
                <b>
                  I / We have read the instructions, terms & conditions and{" "}
                  <a href="PrivacyPolicy" target="_blank" className="links">
                    privacy policy.
                  </a>{" "}
                  Will follow them during registration.
                </b>
              </label>
            </label>
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default Instructions;
